module.exports = __webpack_public_path__ + "static/img/PF151860A.d9a848a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/PF151860A.jpg
// module id = PUHE
// module chunks = 0